import * as React from 'react'

import { StoreDetailsCard } from '../StoreDetailsCard'
import { StoreFacility } from '../StoreDetailsCard/Facilities/Facilities'
import { I18nText as StoreDetailsCardI18nText } from '../StoreDetailsCard/StoreDetailsCard'
import { Status } from '../StoreDetailsCard/StoreStatus'
import { openGoogleDirectionMap } from '../StoreMap/utils'
import { StoreOpeningTime } from '../StoreSearch/types'

import { NearbyStoresContainer, StoreCardsContainer, Title } from './styles'

export interface I18nText {
  nearbyStoresTitle: string
  storeDetailsCard: StoreDetailsCardI18nText
}

interface StoreDetailsNearbyStoresProps {
  nearbyStores: StoreDetailsData['store'][]
  i18nText: I18nText
  storeDetailsHref: (urlTag: string, town: string, region: string) => string
}

export interface StoreDetailsData {
  store: {
    id: string
    displayName: string
    urlTag: string
    phoneNumber: string
    longitude: number
    latitude: number
    relativeDistance: number
    status: Status
    storeFacility: StoreFacility[]
    address: {
      country: string
      addresseeName: string
      addressLine1: string
      addressLine2: string
      addressLine3?: string
      addressLine4: string
      addressLine5: string
      companyName: string
      state?: string
      phoneNumber: string
      postalCode: string
      clickAndCollect?: boolean
    }
    openingTimes: StoreOpeningTime[]
    nearbyStores?: StoreDetailsData['store'][]
  }
}

export const StoreDetailsNearbyStores = (
  props: StoreDetailsNearbyStoresProps,
) => {
  return (
    <NearbyStoresContainer>
      <Title>{props.i18nText.nearbyStoresTitle}</Title>
      <StoreCardsContainer>
        {props.nearbyStores.map((store, index) => (
          <StoreDetailsCard
            store={{
              ...store,
              address: `${
                store.address.addressLine1
                  ? `${store.address.addressLine1},`
                  : ''
              } ${
                store.address.addressLine2
                  ? `${store.address.addressLine2},`
                  : ''
              } ${
                store.address.addressLine3
                  ? `${store.address.addressLine3},`
                  : ''
              }${
                store.address.addressLine4
                  ? `${store.address.addressLine4},`
                  : ''
              } ${store.address.postalCode ? store.address.postalCode : ''}`,
            }}
            i18n={props.i18nText.storeDetailsCard}
            key={`nearby-store-${index}`}
            storeDetailsHref={props.storeDetailsHref(
              store?.urlTag,
              store?.address?.addressLine4
                ?.replace(/\s+/g, '-')
                .toLowerCase() || '',
              store?.address?.addressLine5
                ?.replace(/\s+/g, '-')
                .toLowerCase() || '',
            )}
            getDirectionsHref={openGoogleDirectionMap(
              `${store.latitude},${store.longitude}`,
            )}
          />
        ))}
      </StoreCardsContainer>
    </NearbyStoresContainer>
  )
}
